'use strict'

import AbstractFilesGroup from './AbstractFilesGroup.js'

export default class FilesGroupsContainer extends AbstractFilesGroup {
  constructor (config = {}) {
    super(config)
    this.key = config.key || null
    this.checkDuplicates = config.checkDuplicates || false
    this.filesGroups = []

    if (config.filesGroups) {
      this.addFilesGroups(config.filesGroups)
    }
  }

  getFilesGroups () {
    return this.filesGroups
  }

  addFilesGroups (filesGroups) {
    if (this.sourceConfig) {
      filesGroups.forEach(filesGroup => {
        filesGroup.sourceConfig = this.sourceConfig
      })
    }
    this.filesGroups = [...this.filesGroups, ...filesGroups]
  }

  getFilesGroup (filesGroupKey) {
    return this.filesGroups.find(filesGroup => filesGroup.key === filesGroupKey)
  }

  removeFilesGroups () {
    this.filesGroups = []
  }

  removeFilesGroup (filesGroupKey) {
    const filesGroupToRemoveIndex = this.filesGroups.findIndex(filesGroup => filesGroup.key === filesGroupKey)
    if (filesGroupToRemoveIndex >= 0) {
      this.filesGroups.splice(filesGroupToRemoveIndex, 1)
    }
  }

  addFilesGroup (filesGroup) {
    if (this.sourceConfig) {
      filesGroup.sourceConfig = this.sourceConfig
    }

    const filesGroupKey = filesGroup.key
    if (filesGroupKey) {
      const index = this.filesGroups.findIndex(filesGroup => filesGroup.key === filesGroupKey)
      if (index !== -1) {
        this.filesGroups.splice(index, 1, filesGroup)
        return
      }
    }
    this.filesGroups.push(filesGroup)
  }

  // =========

  // @Override
  hasFiles () {
    return this.filesGroups.find(filesGroup => filesGroup.hasFiles()) != null
  }

  // @Override
  getSelectedFiles () {
    const allSelectedFiles = []
    this.filesGroups.forEach(filesGroup => {
      allSelectedFiles.push(...filesGroup.selectedFiles)
    })
    return allSelectedFiles
  }

  getSelectedFilesData () {
    const filesData = []
    this.filesGroups.forEach(filesGroup => filesData.push(...filesGroup.getSelectedFilesData()))
    return filesData
  }

  // @Override
  clearSelection () {
    this.filesGroups.forEach(filesGroup => filesGroup.clearSelection())
  }

  // @Override
  hasFilesToUpload () {
    return this.filesGroups.find(filesGroup => filesGroup.hasFilesToUpload()) != null
  }

  // @Override
  hasFilesToUpdate () {
    return this.filesGroups.find(filesGroup => filesGroup.hasFilesToUpdate()) != null
  }

  // @Override
  hasFilesToDelete () {
    return this.filesGroups.find(filesGroup => filesGroup.hasFilesToDelete()) != null
  }

  // @Override
  getFilesToUploadData () {
    const filesData = []
    this.filesGroups.forEach(filesGroup => filesData.push(...filesGroup.getFilesToUploadData()))
    return filesData
  }

  getFilesToUpdateData () {
    const filesData = []
    this.filesGroups.forEach(filesGroup => filesData.push(...filesGroup.getFilesToUpdateData()))
    return filesData
  }

  // @Override
  // TODO сделать общее удаление для всех групп
  // Сейчас метод не используется. См. removeDeletedFiles
  getFilesToRemoveData () {
    const filesData = []
    this.filesGroups.forEach(filesGroup => filesData.push(...filesGroup.getFilesToRemoveData()))
    return filesData
  }

  // @Override
  // TODO сделать общее удаление для всех групп
  removeDeletedFiles ({ progress, target }) {
    const removePromises = []
    this.filesGroups.forEach(filesGroup => {
      removePromises.push(filesGroup.removeDeletedFiles({ progress, target }))
    })
    return Promise.allSettled(removePromises)
  }

  // ================================================================================================

  getAllFiles () {
    const allFiles = []
    this.filesGroups.forEach(filesGroup => {
      allFiles.push(...filesGroup.files)
    })
    return allFiles
  }

  getDocumentsIds (fileFilterFn) {
    let files = this.getAllFiles()
    if (fileFilterFn) {
      files = files.filter(fileFilterFn)
    }
    return files.map(file => file.id)
  }

  // --- Валидация

  // @public
  get validFilesGroups () {
    return this.filesGroups.find(filesGroup => this.checkFilesGroupValid(filesGroup, false) === false) == null
  }

  // validateFilesGroups (strict) {
  //   return this.getFilesGroupsValidationMessages(strict).length === 0
  // }

  // @public
  getFilesGroupsValidationMessages (strict) {
    const invalidFilesGroupsMessages = []
    this.filesGroups.forEach(filesGroup => {
      if (!this.validateFilesGroup(filesGroup, strict)) {
        invalidFilesGroupsMessages.push(filesGroup.props.validationMessage)
      }
    })
    return invalidFilesGroupsMessages
  }

  // @private
  validateFilesGroup (filesGroup, strict) {
    const valid = this.checkFilesGroupValid(filesGroup, strict)
    if (filesGroup.props.collapseId) {
      const filesCollapseEl = document.getElementById(filesGroup.props.collapseId)
      if (filesCollapseEl) {
        filesCollapseEl.setAttribute('style', valid ? 'border: none;' : 'border: solid 2px rgb(193, 0, 21);')
      }
    }
    return valid
  }

  // @public
  checkFilesGroupValid (filesGroup, strict) {
    let valid = true
    if (filesGroup.props.required) {
      let hasFiles = !!filesGroup.files.length
      if (!hasFiles && !strict) {
        hasFiles = !!filesGroup.filesToUpload.length
      }
      valid = hasFiles
    }
    if (valid) {
      valid = !(filesGroup.filesToUpload.find(file => !!file.uploadError))
    }
    return valid
  }

  // --

  // @public
  clearFilesGroups () {
    this.filesGroups.forEach(filesGroup => {
      filesGroup.clear()
    })
  }

  // -- Слушатели изменений, проверка на дубликаты

  // @public
  onFileAddToUpload (fileWrapper, target) {
    console.log('onFileAddToUpload, name=', fileWrapper.name, ', hash=', fileWrapper.originalHash)
    if (this.checkDuplicates) {
      const duplicates = this.getFileDuplicates(fileWrapper)
      if (duplicates.length) {
        fileWrapper.uploadError = {
          status: 'error',
          code: 'duplicate',
          message: 'Файл уже был прикреплён'
        }
        duplicates.forEach(fileWrapperDuplicate => {
          fileWrapperDuplicate.uploadError = fileWrapper.uploadError
        })

        if (target) {
          target.$q.notify({
            type: 'negative',
            message: fileWrapper.uploadError.message,
            progress: true,
            timeout: 8000
          })
        }
      }
    }
  }

  // @public
  onFileRemoveFromUpload (fileWrapper) {
    console.log('onFileRemoveFromUpload, name=', fileWrapper.name)
    if (this.checkDuplicates) {
      this.updateDuplicatesOnFileRemove(fileWrapper)
    }
  }

  // @private
  updateDuplicatesOnFileRemove (fileWrapper) {
    const duplicates = this.getFileDuplicates(fileWrapper)
    if (duplicates.length === 1) {
      duplicates[0].uploadError = null
    }
  }

  // @private
  getFileDuplicates (fileWrapper) {
    const duplicates = []
    this.filesGroups.forEach(filesGroup => {
      duplicates.push(...filesGroup.filesToUpload.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))
      duplicates.push(...filesGroup.files.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))
    })
    return duplicates
  }

  // @public
  onFileUploadSuccess ({ document, filesGroup }) {
  }
}
